import { IInputModel, IOptions } from "app/interfaces/input/input.interface";
import { ITextLabel } from "app/interfaces/text-label/textLabel.interface";

export const minimumWithdrawAmount = 100000; // 100k

const reasonList: IOptions[] = [
    {
        label: 'Pengumpulan dana terlalu cepat',
        value: 'Pengumpulan dana terlalu cepat'
    },
    {
        label: 'Tidak banyak pinjaman untuk didanai',
        value: 'Tidak banyak pinjaman untuk didanai'
    },
    {
        label: 'Pilihan pendanaan tidak menarik',
        value: 'Pilihan pendanaan tidak menarik'
    },
    {
        label: 'Kebutuhan pribadi',
        value: 'Kebutuhan pribadi'
    },
    {
        label: 'Melakukan pendanaan di tempat lain',
        value: 'Melakukan pendanaan di tempat lain'
    },
    {
        label: 'Kesalahan pendanaan',
        value: 'Kesalahan pendanaan'
    },
    {
        label: 'Pengalaman pendanaan kurang baik',
        value: 'Pengalaman pendanaan kurang baik'
    },
    {
        label: 'Lain-lain',
        value: 'Lain-lain'
    },
];

export const withdrawForm: IInputModel[] = [
    {
        id: 'withdrawAmount',
        formType: 'currency',
        placeholder: 'Jumlah Tarik Dana',
        name: 'withdrawAmount',
        apiErrorMessage: '',
        value: '',
        disabled: false,
        options: []
    },
    {
        id: 'biayaAdmin',
        formType: 'currency',
        placeholder: 'Biaya Admin',
        name: 'biayaAdmin',
        apiErrorMessage: '',
        value: '',
        disabled: true,
        options: []
    },
    {
        id: 'fundsReceived',
        formType: 'currency',
        placeholder: 'Dana Yang Diterima',
        name: 'fundsReceived',
        apiErrorMessage: '',
        value: '',
        disabled: true,
        options: []
    },
    {
        id: 'reason',
        formType: 'select',
        placeholder: 'Keterangan Penarikan',
        name: 'reason',
        apiErrorMessage: '',
        value: '',
        disabled: false,
        options: reasonList
    }
];

export const passwordForm: IInputModel[] = [
    {
        id: 'password',
        formType: 'password',
        placeholder: 'Kata Sandi',
        name: 'password',
        apiErrorMessage: '',
        value: '',
        disabled: false,
        options: []
    },
];

export const bankAccountTextLabel: ITextLabel[] = [
    {
        title: 'Nama',
        value: '',
        bg: false,
        loading: false,
        ellipsis: true
    },
    {
        title: 'Nomor Rekening',
        value: '',
        bg: false,
        loading: false,
        ellipsis: false
    }
];

export const WRONG_PASSWORD = 'Invalid input password. Please try again';
export const WRONG_PASSWORD_IN = 'Kata Sandi tidak sesuai, mohon coba lagi';
